// extracted by mini-css-extract-plugin
module.exports = {"seriesListWrapper":"oW","fullWidth":"oX","seriesListTabWrapper":"oY","tab":"oZ","active":"o0"};